import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Col } from 'react-bootstrap';
import Widget from '../Widget';
import { getProjectIssuesCount } from '../../../../../../modules/jira';
import { fetchUserStoriesCovered } from '../../../../../../modules/dashboard';

const TestRequirementCoverage = ({
  projectId,
  selectedJiraProject,
  isJiraIntegrated,
}) => {
  const jiraProjectId = selectedJiraProject?.linked_project_id;

  const { data: totalStories, isLoading: isLoadingTotal } = useQuery({
    queryKey: ['totalStories', projectId, jiraProjectId],
    queryFn: () =>
      getProjectIssuesCount(
        `project = ${jiraProjectId} AND issuetype = 'Story'`,
        projectId,
        jiraProjectId,
      ),
    enabled: isJiraIntegrated && !!jiraProjectId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  const { data: coveredStories, isLoading: isLoadingCovered } = useQuery({
    queryKey: ['coveredStories', projectId, jiraProjectId],
    queryFn: () => fetchUserStoriesCovered(projectId, jiraProjectId),
    enabled: isJiraIntegrated && !!jiraProjectId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  const percentageCovered = useMemo(() => {
    if (totalStories && coveredStories && totalStories.count > 0) {
      return Math.round((coveredStories.count / totalStories.count) * 100);
    }
    return 0;
  }, [totalStories, coveredStories]);

  return (
    <>
      <Col className="test-cycle-widget">
        <Widget
          title="Total Stories in Jira"
          body={totalStories?.count}
          showWarning={!isJiraIntegrated}
          loading={isLoadingTotal}
          link={totalStories?.jira_url}
        />
      </Col>
      <Col className="test-cycle-widget">
        <Widget
          title="Stories Covered"
          body={coveredStories?.count}
          showWarning={!isJiraIntegrated}
          loading={isLoadingCovered}
          link={coveredStories?.jira_url}
        />
      </Col>
      <Col className="test-cycle-widget">
        <Widget
          title="Test Coverage"
          body={percentageCovered}
          percentage
          showWarning={!isJiraIntegrated}
          loading={isLoadingTotal || isLoadingCovered}
        />
      </Col>
    </>
  );
};

export default React.memo(TestRequirementCoverage);
